var _a;
import { EXTERNAL_ROUTES, IMAGE_BASE_URL } from '../../../constants/values';
import { QuizPageStrings } from './QuizV2Strings';
var questions = QuizPageStrings.questions, recommendations = QuizPageStrings.recommendations;
export var QuizQuestionId;
(function (QuizQuestionId) {
    QuizQuestionId["whereIsTeam"] = "whereIsTeam";
    QuizQuestionId["howToOrder"] = "howToOrder";
    QuizQuestionId["howOften"] = "howOften";
    QuizQuestionId["workEmail"] = "workEmail";
})(QuizQuestionId || (QuizQuestionId = {}));
export var WhereIsTeamResponseId = {
    remote: 'remote',
    inOfficeOrHybrid: 'inOfficeOrHybrid',
};
var WhereIsTeamQuestionData = {
    id: QuizQuestionId.whereIsTeam,
    question: questions.whereIsTeam.question(),
    options: [
        {
            id: WhereIsTeamResponseId.remote,
            title: questions.whereIsTeam.option1.title(),
            subtitle: questions.whereIsTeam.option1.subtitle(),
            url: IMAGE_BASE_URL + "/s/managed/consumer/teams/on-laptop.png",
        },
        {
            id: WhereIsTeamResponseId.inOfficeOrHybrid,
            title: questions.whereIsTeam.option2.title(),
            subtitle: questions.whereIsTeam.option2.subtitle(),
            url: IMAGE_BASE_URL + "/s/managed/consumer/teams/in-office-work.png",
        },
    ],
};
export var HowToOrderResponseId = {
    themselves: 'themselves',
    together: 'everyoneTogether',
};
var HowToOrderQuestionData = {
    id: QuizQuestionId.howToOrder,
    question: questions.howToOrder.question(),
    options: [
        {
            id: HowToOrderResponseId.themselves,
            title: questions.howToOrder.option1.title(),
        },
        {
            id: HowToOrderResponseId.together,
            title: questions.howToOrder.option2.title(),
        },
    ],
};
export var HowOftenResponseId = {
    oneTime: 'oneTime',
    regularly: 'regularly',
};
var HowOftenQuestionData = {
    id: QuizQuestionId.howOften,
    question: questions.howOften.question(),
    options: [
        {
            id: HowOftenResponseId.oneTime,
            title: questions.howOften.option1.title(),
        },
        {
            id: HowOftenResponseId.regularly,
            title: questions.howOften.option2.title(),
        },
    ],
};
var WorkEmailQuestionData = {
    id: QuizQuestionId.workEmail,
    question: questions.workEmail.question(),
    email: {
        label: questions.workEmail.label(),
    },
};
export var QuestionsData = {
    WhereIsTeamQuestionData: WhereIsTeamQuestionData,
    HowToOrderQuestionData: HowToOrderQuestionData,
    HowOftenQuestionData: HowOftenQuestionData,
    WorkEmailQuestionData: WorkEmailQuestionData,
};
export var ProductOffering;
(function (ProductOffering) {
    ProductOffering["groupOrder"] = "Group Order";
    ProductOffering["catering"] = "Catering";
    ProductOffering["expensedMeals"] = "Expensed Meals";
})(ProductOffering || (ProductOffering = {}));
var GroupOrderRecommendation = {
    id: ProductOffering.groupOrder,
    title: recommendations.groupOrder.title(),
    subtitle: recommendations.groupOrder.subtitle(),
    whyProduct: {
        label: recommendations.groupOrder.whyGroupOrder(),
        descriptions: [
            recommendations.groupOrder.whyDescription1(),
            recommendations.groupOrder.whyDescription2(),
            recommendations.groupOrder.whyDescription3(),
        ],
    },
    button: {
        text: recommendations.groupOrder.ctaText(),
        link: EXTERNAL_ROUTES.MARKETPLACE,
    },
    modalCta: {
        text: recommendations.groupOrder.modalCtaText(),
    },
    imageUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/eat-together.png",
};
var CateringRecommendation = {
    id: ProductOffering.catering,
    title: recommendations.catering.title(),
    subtitle: recommendations.catering.subtitle(),
    whyProduct: {
        label: recommendations.catering.whyCatering(),
        descriptions: [
            recommendations.catering.whyDescription1(),
            recommendations.catering.whyDescription2(),
            recommendations.catering.whyDescription3(),
        ],
    },
    button: {
        text: recommendations.catering.ctaText(),
        link: EXTERNAL_ROUTES.CATERING_NEAR_ME,
    },
    imageUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/catering.png",
};
var ExpensedMealsRecommendation = {
    id: ProductOffering.expensedMeals,
    title: recommendations.expensedMeals.title(),
    subtitle: recommendations.expensedMeals.subtitle(),
    whyProduct: {
        label: recommendations.expensedMeals.whyExpensedMeals(),
        descriptions: [
            recommendations.expensedMeals.whyDescription1(),
            recommendations.expensedMeals.whyDescription2(),
            recommendations.expensedMeals.whyDescription3(),
        ],
    },
    button: {
        text: recommendations.expensedMeals.ctaText(),
    },
    imageUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/ordering.png",
};
export var RecommendedProducts = (_a = {},
    _a[ProductOffering.groupOrder] = GroupOrderRecommendation,
    _a[ProductOffering.catering] = CateringRecommendation,
    _a[ProductOffering.expensedMeals] = ExpensedMealsRecommendation,
    _a);
var HowToPlaceOrderSteps = [
    {
        text: recommendations.howToPlaceOrderModal.step1(),
    },
    {
        text: recommendations.howToPlaceOrderModal.step2(),
        img: {
            src: IMAGE_BASE_URL + "/s/managed/consumer/teams/group-order-highlight.png",
            alt: 'group order button in stores page',
            height: 56,
        },
    },
    {
        text: recommendations.howToPlaceOrderModal.step3(),
        img: {
            src: IMAGE_BASE_URL + "/s/managed/consumer/teams/group-order-limit.png",
            alt: 'add limit per person for group orders',
            height: 128,
        },
    },
    {
        text: recommendations.howToPlaceOrderModal.step4(),
        img: {
            src: IMAGE_BASE_URL + "/s/managed/consumer/teams/group-order-invite.png",
            alt: 'copy group order link for invitation',
            height: 144,
        },
    },
    {
        text: recommendations.howToPlaceOrderModal.step5(),
    },
];
export var HowToPlaceOrderData = {
    title: recommendations.howToPlaceOrderModal.title(),
    steps: HowToPlaceOrderSteps,
    primaryCta: {
        text: recommendations.howToPlaceOrderModal.primaryActionText(),
    },
    secondaryCta: {
        text: recommendations.howToPlaceOrderModal.secondaryActionText(),
    },
};
